export default __webpack_public_path__ + "static/media/gradient-dark.0c20c7e8.png";